import { jsx as Y } from "react/jsx-runtime";
import * as s from "react";
import { forwardRef as Z } from "react";
import { n as ee } from "./emotion-styled.browser.esm.js";
import { R as oe, a as ne } from "./ExclamationCircleFilled.js";
import { R as te } from "./CloseCircleFilled.js";
import { R as re } from "./CloseOutlined.js";
import { R as se } from "./InfoCircleFilled.js";
import { g as ie, o as ce, u as B, E as ae, n as v, y as le, z as de, F as j, G as me, H as pe, I as ue, a as fe, b as ge } from "./CSSMotionList.js";
import { p as ye } from "./pickAttrs.js";
import { r as Ce } from "./reactNode.js";
import { d as $e } from "./warning.js";
const S = (e, o, n, t, r) => ({
  background: e,
  border: `${B(t.lineWidth)} ${t.lineType} ${o}`,
  [`${r}-icon`]: {
    color: n
  }
}), be = (e) => {
  const {
    componentCls: o,
    motionDurationSlow: n,
    marginXS: t,
    marginSM: r,
    fontSize: i,
    fontSizeLG: l,
    lineHeight: d,
    borderRadiusLG: p,
    motionEaseInOutCirc: m,
    withDescriptionIconSize: f,
    colorText: g,
    colorTextHeading: $,
    withDescriptionPadding: b,
    defaultPadding: c
  } = e;
  return {
    [o]: Object.assign(Object.assign({}, ce(e)), {
      position: "relative",
      display: "flex",
      alignItems: "center",
      padding: c,
      wordWrap: "break-word",
      borderRadius: p,
      [`&${o}-rtl`]: {
        direction: "rtl"
      },
      [`${o}-content`]: {
        flex: 1,
        minWidth: 0
      },
      [`${o}-icon`]: {
        marginInlineEnd: t,
        lineHeight: 0
      },
      "&-description": {
        display: "none",
        fontSize: i,
        lineHeight: d
      },
      "&-message": {
        color: $
      },
      [`&${o}-motion-leave`]: {
        overflow: "hidden",
        opacity: 1,
        transition: `max-height ${n} ${m}, opacity ${n} ${m},
        padding-top ${n} ${m}, padding-bottom ${n} ${m},
        margin-bottom ${n} ${m}`
      },
      [`&${o}-motion-leave-active`]: {
        maxHeight: 0,
        marginBottom: "0 !important",
        paddingTop: 0,
        paddingBottom: 0,
        opacity: 0
      }
    }),
    [`${o}-with-description`]: {
      alignItems: "flex-start",
      padding: b,
      [`${o}-icon`]: {
        marginInlineEnd: r,
        fontSize: f,
        lineHeight: 0
      },
      [`${o}-message`]: {
        display: "block",
        marginBottom: t,
        color: $,
        fontSize: l
      },
      [`${o}-description`]: {
        display: "block",
        color: g
      }
    },
    [`${o}-banner`]: {
      marginBottom: 0,
      border: "0 !important",
      borderRadius: 0
    }
  };
}, he = (e) => {
  const {
    componentCls: o,
    colorSuccess: n,
    colorSuccessBorder: t,
    colorSuccessBg: r,
    colorWarning: i,
    colorWarningBorder: l,
    colorWarningBg: d,
    colorError: p,
    colorErrorBorder: m,
    colorErrorBg: f,
    colorInfo: g,
    colorInfoBorder: $,
    colorInfoBg: b
  } = e;
  return {
    [o]: {
      "&-success": S(r, t, n, e, o),
      "&-info": S(b, $, g, e, o),
      "&-warning": S(d, l, i, e, o),
      "&-error": Object.assign(Object.assign({}, S(f, m, p, e, o)), {
        [`${o}-description > pre`]: {
          margin: 0,
          padding: 0
        }
      })
    }
  };
}, Ie = (e) => {
  const {
    componentCls: o,
    iconCls: n,
    motionDurationMid: t,
    marginXS: r,
    fontSizeIcon: i,
    colorIcon: l,
    colorIconHover: d
  } = e;
  return {
    [o]: {
      "&-action": {
        marginInlineStart: r
      },
      [`${o}-close-icon`]: {
        marginInlineStart: r,
        padding: 0,
        overflow: "hidden",
        fontSize: i,
        lineHeight: B(i),
        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        [`${n}-close`]: {
          color: l,
          transition: `color ${t}`,
          "&:hover": {
            color: d
          }
        }
      },
      "&-close-text": {
        color: l,
        transition: `color ${t}`,
        "&:hover": {
          color: d
        }
      }
    }
  };
}, Se = (e) => ({
  withDescriptionIconSize: e.fontSizeHeading3,
  defaultPadding: `${e.paddingContentVerticalSM}px 12px`,
  withDescriptionPadding: `${e.paddingMD}px ${e.paddingContentHorizontalLG}px`
}), ve = ie("Alert", (e) => [be(e), he(e), Ie(e)], Se);
var M = function(e, o) {
  var n = {};
  for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)
    o.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (n[t[r]] = e[t[r]]);
  return n;
};
const Ee = {
  success: oe,
  info: se,
  error: te,
  warning: ne
}, xe = (e) => {
  const {
    icon: o,
    prefixCls: n,
    type: t
  } = e, r = Ee[t] || null;
  return o ? Ce(o, /* @__PURE__ */ s.createElement("span", {
    className: `${n}-icon`
  }, o), () => ({
    className: v(`${n}-icon`, o.props.className)
  })) : /* @__PURE__ */ s.createElement(r, {
    className: `${n}-icon`
  });
}, we = (e) => {
  const {
    isClosable: o,
    prefixCls: n,
    closeIcon: t,
    handleClose: r,
    ariaProps: i
  } = e, l = t === !0 || t === void 0 ? /* @__PURE__ */ s.createElement(re, null) : t;
  return o ? /* @__PURE__ */ s.createElement("button", Object.assign({
    type: "button",
    onClick: r,
    className: `${n}-close-icon`,
    tabIndex: 0
  }, i), l) : null;
}, E = /* @__PURE__ */ s.forwardRef((e, o) => {
  const {
    description: n,
    prefixCls: t,
    message: r,
    banner: i,
    className: l,
    rootClassName: d,
    style: p,
    onMouseEnter: m,
    onMouseLeave: f,
    onClick: g,
    afterClose: $,
    showIcon: b,
    closable: c,
    closeText: h,
    closeIcon: y,
    action: x,
    id: z
  } = e, _ = M(e, ["description", "prefixCls", "message", "banner", "className", "rootClassName", "style", "onMouseEnter", "onMouseLeave", "onClick", "afterClose", "showIcon", "closable", "closeText", "closeIcon", "action", "id"]), [w, A] = s.useState(!1);
  process.env.NODE_ENV !== "production" && $e("Alert").deprecated(!h, "closeText", "closable.closeIcon");
  const N = s.useRef(null);
  s.useImperativeHandle(o, () => ({
    nativeElement: N.current
  }));
  const {
    getPrefixCls: D,
    direction: T,
    closable: C,
    closeIcon: O,
    className: L,
    style: W
  } = ae("alert"), a = D("alert", t), [k, V, G] = ve(a), X = (u) => {
    var I;
    A(!0), (I = e.onClose) === null || I === void 0 || I.call(e, u);
  }, R = s.useMemo(() => e.type !== void 0 ? e.type : i ? "warning" : "info", [e.type, i]), F = s.useMemo(() => typeof c == "object" && c.closeIcon || h ? !0 : typeof c == "boolean" ? c : y !== !1 && y !== null && y !== void 0 ? !0 : !!C, [h, y, c, C]), P = i && b === void 0 ? !0 : b, U = v(a, `${a}-${R}`, {
    [`${a}-with-description`]: !!n,
    [`${a}-no-icon`]: !P,
    [`${a}-banner`]: !!i,
    [`${a}-rtl`]: T === "rtl"
  }, L, l, d, G, V), q = ye(_, {
    aria: !0,
    data: !0
  }), J = s.useMemo(() => typeof c == "object" && c.closeIcon ? c.closeIcon : h || (y !== void 0 ? y : typeof C == "object" && C.closeIcon ? C.closeIcon : O), [y, c, h, O]), K = s.useMemo(() => {
    const u = c ?? C;
    return typeof u == "object" ? M(u, ["closeIcon"]) : {};
  }, [c, C]);
  return k(/* @__PURE__ */ s.createElement(le, {
    visible: !w,
    motionName: `${a}-motion`,
    motionAppear: !1,
    motionEnter: !1,
    onLeaveStart: (u) => ({
      maxHeight: u.offsetHeight
    }),
    onLeaveEnd: $
  }, ({
    className: u,
    style: I
  }, Q) => /* @__PURE__ */ s.createElement("div", Object.assign({
    id: z,
    ref: de(N, Q),
    "data-show": !w,
    className: v(U, u),
    style: Object.assign(Object.assign(Object.assign({}, W), p), I),
    onMouseEnter: m,
    onMouseLeave: f,
    onClick: g,
    role: "alert"
  }, q), P ? /* @__PURE__ */ s.createElement(xe, {
    description: n,
    icon: e.icon,
    prefixCls: a,
    type: R
  }) : null, /* @__PURE__ */ s.createElement("div", {
    className: `${a}-content`
  }, r ? /* @__PURE__ */ s.createElement("div", {
    className: `${a}-message`
  }, r) : null, n ? /* @__PURE__ */ s.createElement("div", {
    className: `${a}-description`
  }, n) : null), x ? /* @__PURE__ */ s.createElement("div", {
    className: `${a}-action`
  }, x) : null, /* @__PURE__ */ s.createElement(we, {
    isClosable: F,
    prefixCls: a,
    closeIcon: J,
    handleClose: X,
    ariaProps: K
  }))));
});
process.env.NODE_ENV !== "production" && (E.displayName = "Alert");
function Ne(e, o, n) {
  return o = j(o), me(e, pe() ? Reflect.construct(o, n || [], j(e).constructor) : o.apply(e, n));
}
let Oe = /* @__PURE__ */ function(e) {
  function o() {
    var n;
    return ge(this, o), n = Ne(this, o, arguments), n.state = {
      error: void 0,
      info: {
        componentStack: ""
      }
    }, n;
  }
  return ue(o, e), fe(o, [{
    key: "componentDidCatch",
    value: function(t, r) {
      this.setState({
        error: t,
        info: r
      });
    }
  }, {
    key: "render",
    value: function() {
      const {
        message: t,
        description: r,
        id: i,
        children: l
      } = this.props, {
        error: d,
        info: p
      } = this.state, m = (p == null ? void 0 : p.componentStack) || null, f = typeof t > "u" ? (d || "").toString() : t, g = typeof r > "u" ? m : r;
      return d ? /* @__PURE__ */ s.createElement(E, {
        id: i,
        type: "error",
        message: f,
        description: /* @__PURE__ */ s.createElement("pre", {
          style: {
            fontSize: "0.9em",
            overflowX: "auto"
          }
        }, g)
      }) : l;
    }
  }]);
}(s.Component);
const H = E;
H.ErrorBoundary = Oe;
const Re = ee(H)`
  .ant-alert-message {
    font-weight: ${({ theme: e }) => e.fontWeight.medium};
  }
`, We = Z(
  ({ appearance: e, icon: o = !0, ...n }, t) => /* @__PURE__ */ Y(Re, { ref: t, ...n, type: e, ...typeof o == "boolean" ? { showIcon: o } : { icon: o, showIcon: !0 } })
);
export {
  We as A
};
